// Prepara la portada de una canción o el flyer de un evento para compartirlo
// como IMAGEN (no como link) desde el celular.
//
// Las imágenes se guardan en WebP, y Instagram y Facebook no siempre lo
// aceptan cuando les llega desde la hoja de compartir del sistema: la app no
// aparece en la lista, o aparece y falla. Por eso se convierte a JPEG antes
// de compartir o de descargar.
//
// La descarga se hace por adelantado, al abrir el modal, y no al tocar el
// botón: el navegador solo deja abrir la hoja de compartir en respuesta
// directa a un toque, y si en medio se espera una descarga, Safari considera
// que el toque ya pasó y no la abre.

function cargarImagen(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = url;
  });
}

async function aJpeg(blob) {
  if (blob.type === "image/jpeg") return blob;
  const url = URL.createObjectURL(blob);
  try {
    const img = await cargarImagen(url);
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    const ctx = canvas.getContext("2d");
    // JPEG no tiene transparencia: lo transparente quedaría negro.
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.drawImage(img, 0, 0);
    return await new Promise((resolve, reject) =>
      canvas.toBlob(
        (jpeg) => (jpeg ? resolve(jpeg) : reject(new Error("toBlob"))),
        "image/jpeg",
        0.92
      )
    );
  } finally {
    URL.revokeObjectURL(url);
  }
}

// "Noche de Rock en el Foro" → "noche-de-rock-en-el-foro"
export function nombreDeArchivo(texto, respaldo = "imagen") {
  const limpio = String(texto || "")
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 60);
  return limpio || respaldo;
}

// Devuelve un File JPEG. Si la conversión falla, el archivo original: es
// mejor intentar compartir el WebP que no compartir nada.
export async function imagenParaCompartir(url, nombre) {
  const resp = await fetch(url, { mode: "cors" });
  if (!resp.ok) throw new Error(`No se pudo descargar la imagen (${resp.status})`);
  const original = await resp.blob();
  const blob = await aJpeg(original).catch(() => original);
  const extension = blob.type === "image/jpeg" ? "jpg" : (blob.type.split("/")[1] || "jpg");
  return new File([blob], `${nombre}.${extension}`, {
    type: blob.type || "image/jpeg",
  });
}

// Si este navegador puede mandar el archivo a otra app (Instagram, Facebook…)
// con la hoja de compartir del sistema. En la mayoría de las computadoras no.
export function puedeCompartirArchivo(archivo) {
  try {
    return Boolean(
      archivo &&
        typeof navigator !== "undefined" &&
        navigator.canShare &&
        navigator.canShare({ files: [archivo] })
    );
  } catch (e) {
    return false;
  }
}
